import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ScreenContext = createContext();

export const ScreenProvider = ({ children }) => {
  const [userScreens, setUserScreens] = useState([]);
  const [, setNavigationStack] = useState([]);
  const navigate = useNavigate();

  const loadScreens = async (perfilId, versaoId) => {
    try {
      const response = await axios.get(
        `/api/Permissao/perfil/${perfilId}/versao/${versaoId}`
      );
      if (response.data.success) {
        setUserScreens(response.data.data.map((tela) => tela.path));
      }
    } catch (error) {
      console.error("Erro ao carregar telas:", error);
    }
  };

  const openScreen = (path) => {
    setNavigationStack((prevStack) => [...prevStack, path]);
    navigate(path);
  };

  const closeScreen = () => {
    setNavigationStack((prevStack) => {
      const newStack = [...prevStack];
      newStack.pop();
      const previousPath = newStack[newStack.length - 1];
      if (previousPath) navigate(previousPath);
      return newStack;
    });
  };

  return (
    <ScreenContext.Provider
      value={{ userScreens, loadScreens, openScreen, closeScreen }}
    >
      {children}
    </ScreenContext.Provider>
  );
};

export const useScreenContext = () => useContext(ScreenContext);
